module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "services"
  }, [_c('nav', {
    staticClass: "sub-menu"
  }, [_c('span', {
    staticClass: "button-wrapper centered",
    on: {
      "click": _vm.addService
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Услуга")]), _vm._v(" "), _c('ul', {
    staticClass: "centered"
  }, _vm._l((_vm.services), function(item) {
    return _c('li', {
      on: {
        "click": _vm.handleGetService
      }
    }, [_c('router-link', {
      key: item.id,
      class: !_vm.$route.params.id && item.id === _vm.services[0].id ? 'is-active' : '',
      attrs: {
        "to": {
          name: 'Service',
          params: {
            id: item.id
          }
        },
        "active-class": "is-active"
      }
    }, [_vm._v("\n          " + _vm._s(item.title) + "\n        ")])], 1)
  }), 0)]), _vm._v(" "), (_vm.service) ? _c('Service') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2436d403"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Services/Index.vue
// module id = 911
// module chunks = 0